import {api} from '../../system/api';

export default {
    getUsers: (params) => api.get('users', {params}),
    fetchDetailUser: (userId) => api.get('shipping-users/' + userId, {}, {singleRequest: true}),
};
